import "./src/styles/global.css";

const onRenderBody = ({ setHtmlAttributes }) => {
  setHtmlAttributes({ lang: "de" });
};

export default onRenderBody;
